import { unit } from '@ant-design/cssinjs';
const genSummaryStyle = token => {
  const {
    componentCls,
    lineWidth,
    tableBorderColor,
    calc
  } = token;
  const tableBorder = "".concat(unit(lineWidth), " ").concat(token.lineType, " ").concat(tableBorderColor);
  return {
    ["".concat(componentCls, "-wrapper")]: {
      ["".concat(componentCls, "-summary")]: {
        position: 'relative',
        zIndex: token.zIndexTableFixed,
        background: token.tableBg,
        '> tr': {
          '> th, > td': {
            borderBottom: tableBorder
          }
        }
      },
      ["div".concat(componentCls, "-summary")]: {
        boxShadow: "0 ".concat(unit(calc(lineWidth).mul(-1).equal()), " 0 ").concat(tableBorderColor)
      }
    }
  };
};
export default genSummaryStyle;